<template>
<div>
    <el-container>
        <el-main>
            <img src="../../public/logo.png" alt="logo" style="width: 100%">
            <el-form label-position="left" label-width="140px" :model="form" size="medium">
                <el-form-item label="Email">
                    <el-input class="email-password" v-model="form.email" readonly></el-input>
                </el-form-item>
                <el-form-item label="New Password">
                    <el-input class="email-password" v-model="form.newPassword" show-password></el-input>
                </el-form-item>
                 <el-form-item  label="Confirm Password">
                    <el-input  class="email-password" v-model="form.confirmPassword" show-password></el-input>
                </el-form-item>
                <el-form-item class="form-buttons" label-width="0">
                    <el-button type="success" v-on:click="changePassword">Confirm</el-button>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</div>
</template>

<script>
import { showMessage } from "../utils";
import { mapState } from "vuex";
import { Auth } from 'aws-amplify';


export default {
  name: "ForgotPassword",
  data: function() {
    return {
      form: {
        email:"",
        code:"",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  mounted() {
      this.form.email = this.$route.query.email
      this.form.code = this.$route.query.code
  },
  methods: {
    changePassword() {
      if (
        this.form.newPassword === this.form.confirmPassword
      ) {
        Auth.forgotPasswordSubmit(
                this.form.email.toLowerCase(),
                this.form.code,
                this.form.newPassword
            )
                .then(() => {
                    showMessage('Password changed successfully', 'success')
                    this.$router.push({
                    name: "Home",
                });
                })
                .catch(() => {
                    showMessage('Could not change password', 'error')
                });
      } else {
        showMessage('Password and confirm password do not match.', 'error')
      }
    },
    onClose() {
      this.changePasswordVisible = false;
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.authLoading,
    }),
  },
};
</script>

<style>
.el-header {
    text-align: center;
    font-size: xx-large;
}
</style>

<style scoped>
.el-main {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
    margin: 55px auto;
}

.form-buttons {
    text-align: center;
}

.email-password{
    width:100%;
}
</style>
